module.exports = __webpack_public_path__ + "static/media/frontend.b40061a3.svg";